import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as RolesActions } from 'store/ducks/roles';

import { Access } from 'common';
import { Page, Panel, Loading, Pagination, Breadcrumbs, Icon } from 'components';

class List extends Component {
  state = {
    breadcrumbs: [{ name: 'Home', to: '/' }, { name: 'Configurações', to: '/configs' }, { name: 'Permissões', to: '' }],
  };

  componentDidMount() {
    const { location, getRolesRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getRolesRequest(page);
  }

  componentDidUpdate(oldProps) {
    const { location, getRolesRequest } = this.props;

    if (queryString.parse(oldProps.location.search).page !== queryString.parse(location.search).page) {
      getRolesRequest(queryString.parse(location.search).page);
    }
  }

  render() {
    const { breadcrumbs } = this.state;
    const { roles } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Permissões</Page.Title>

        <Panel className="panel-list">
          {!roles.data.length && roles.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {roles.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>nome</th>
                    <th>alias</th>
                    <th>descrição</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>
                <tbody>
                  {!roles.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {roles.data.map((role, index) => (
                    <tr key={role.id}>
                      <td>{role.attributes.title}</td>
                      <td>{role.attributes.alias}</td>
                      <td>{role.attributes.description}</td>
                      <td className="text-right">
                        {Access.hasPermissions('edit-permissions') && (
                          <Link to={`/configs/roles/${role.id}/edit`} className="button-icon">
                            <Icon name="pencil" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination current={roles.page} total={roles.totals} {...this.props} />

              {Access.hasPermissions('edit-permissions') && (
                <Link className="button-add" to="/configs/roles/create">
                  Adicionar Permissão
                </Link>
              )}
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  roles: state.roles,
});

const mapActions = dispatch => bindActionCreators(RolesActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(List);
